import { render, staticRenderFns } from "./ConflictSolution.vue?vue&type=template&id=64c316ba&scoped=true"
import script from "./ConflictSolution.vue?vue&type=script&lang=js"
export * from "./ConflictSolution.vue?vue&type=script&lang=js"
import style0 from "./ConflictSolution.vue?vue&type=style&index=0&id=64c316ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c316ba",
  null
  
)

export default component.exports